import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import colors from '../../../../../constants/colors';
import HouseFancy from '../../../../../icons/HouseFancy';

import styles from './EmbedPropertyListEmpty.module.scss';

const EmbedPropertyListEmpty = ({ className }) => {
  return (
    <div className={cx(styles.container, className)}>
      <HouseFancy
        className={styles.icon}
        height={92}
        width={116}
        color={colors.darkBlueGrey}
      />
      <h2 className={styles.title}>
        There are currently no rental properties available.
      </h2>
    </div>
  );
};

EmbedPropertyListEmpty.propTypes = {
  className: PropTypes.string,
};

export default EmbedPropertyListEmpty;
